import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { eventos } from '../data/eventos';
import { cultura } from '../data/cultura';
import { recomendaciones } from '../data/recomendaciones';
import { normalizarBloques } from './normalizarBloques';

export async function seedFirestore(onProgress) {
  const total = eventos.length + cultura.length + recomendaciones.length;
  let done = 0;

  for (let i = 0; i < eventos.length; i++) {
    const e = eventos[i];
    await setDoc(doc(db, 'eventos', e.slug), {
      slug: e.slug,
      titulo: e.titulo || '',
      descripcionCorta: e.descripcionCorta || '',
      descripcionLarga: normalizarBloques(e.descripcionLarga),
      fecha: e.fecha || '',
      hora: e.hora || '',
      lugar: e.lugar || '',
      imagen: e.imagen || '',
      link: e.link || '',
      url: e.url || '',
      orden: i,
    });
    done++;
    onProgress?.(Math.round((done / total) * 100));
  }

  for (let i = 0; i < cultura.length; i++) {
    const c = cultura[i];
    await setDoc(doc(db, 'cultura', c.slug), {
      slug: c.slug,
      titulo: c.titulo || '',
      descripcionCorta: c.descripcionCorta || '',
      descripcionLarga: c.descripcionLarga || '',
      docentes: c.docentes || '',
      dia: c.dia || '',
      fecha: c.fecha || '',
      horario: c.horario || '',
      ubicacion: c.ubicacion || '',
      inicio: c.inicio || '',
      valor: c.valor || '',
      requisitos: c.requisitos || '',
      cupo: c.cupo || '',
      imagen: c.imagen || '',
      link: c.link || '',
      link_1: c.link_1 || '',
      link_1_label: c.link_1_label || '',
      link_2: c.link_2 || '',
      link_2_label: c.link_2_label || '',
      orden: i,
    });
    done++;
    onProgress?.(Math.round((done / total) * 100));
  }

  for (let i = 0; i < recomendaciones.length; i++) {
    const r = recomendaciones[i];
    await setDoc(doc(db, 'recomendaciones', r.slug), {
      slug: r.slug,
      titulo: r.titulo || '',
      descripcionCorta: r.descripcionCorta || '',
      descripcionLarga: r.descripcionLarga || '',
      imagen: r.imagen || '',
      epigrafe: r.epigrafe || '',
      orden: i,
    });
    done++;
    onProgress?.(Math.round((done / total) * 100));
  }
}
